import { render, staticRenderFns } from "./DevicesStatistics.vue?vue&type=template&id=0267ede8&scoped=true"
import script from "./DevicesStatistics.vue?vue&type=script&lang=js"
export * from "./DevicesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0267ede8",
  null
  
)

export default component.exports